module.exports = __webpack_public_path__ + "static/media/img_admission_03.7d907589.png";